import axios from "lib/axios";

const getPreferencesForTimeline = async ({ timelineId }) => {
  // console.log("api instance band:",band)
  const { data } = await axios.get(`/timeline/${timelineId}/preferences`);
  return data;
};
const getPreferenceDetails = async ({ preferenceId }) => {
  // console.log("api instance band:",band)
  const { data } = await axios.get(`/preference/${preferenceId}`);
  return data;
};

const setNewPreference = async ({ preferences }) => {
  // console.log("api instance band:",band)
  const { data } = await axios.post(`/preference`, preferences);
  return data;
};
export { getPreferencesForTimeline, getPreferenceDetails, setNewPreference };
